import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type {
  IImportTmdbCreditsBody,
  IImportTmdbCreditsResponse,
} from './import-tmdb-credits-response';
import { importTmdbCreditsResponseSchema } from './import-tmdb-credits-response';

export async function importTmdbCreditsApi(
  body: IImportTmdbCreditsBody,
): Promise<IValidatedResponse<IImportTmdbCreditsResponse>> {
  return postRequest<IImportTmdbCreditsResponse>({
    path: '/sys/people/v1/import/tmdb',
    body,
    schema: importTmdbCreditsResponseSchema,
  });
}
